import * as React from 'react';
import PropTypes from 'prop-types';
import Header from '../header/header';
import Footer from '../footer/footer';
import BannerComponent from '../banner/banner';
import './layout.scss';

interface Props {
  hideFooter?: boolean;
  showIconOnly?: boolean;
  children: React.ReactNode;
}

const Layout: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <>
      <Header showIconOnly={props.showIconOnly} />
      <div id="layout-wrapper">
        <main>{props.children}</main>
      </div>
      {props.hideFooter && <Footer />}
      {/* <BannerComponent /> */}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  hideFooter: PropTypes.bool,
  showIconOnly: PropTypes.bool,
};

Layout.defaultProps = {
  hideFooter: true,
  showIconOnly: false,
};

export default Layout;
